import React from "react";
import { AbsoluteFill, interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { COLORS, FONTS, SPRING, STAKE } from "./constants";
import { Backdrop, SceneTitle, glow } from "./shared";

const STAKES = [
  { icon: "👔", label: "The Founder",        role: "Runs the whole show", c: STAKE.founder },
  { icon: "🧑‍💻", label: "Knowledge Worker",  role: "Executes every day",  c: STAKE.worker },
  { icon: "🤝", label: "Customer Success",   role: "Keeps accounts alive", c: STAKE.success },
];

export const Scene03Trio: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps, durationInFrames } = useVideoConfig();

  const fade = interpolate(frame, [durationInFrames - 30, durationInFrames], [1, 0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  });

  const titleSp = spring({ frame, fps, config: SPRING.snappy });
  const titleAp = interpolate(titleSp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  return (
    <AbsoluteFill style={{ background: COLORS.bg, opacity: fade, overflow: "hidden" }}>
      <Backdrop frame={frame} accent={COLORS.neonPurple} />
      <SceneTitle text="Three stakeholders. Three pains." color={COLORS.textPrimary} frame={frame} appear={titleAp} />

      {/* 3D pedestals */}
      <div style={{
        position: "absolute", top: 260, left: 0, right: 0,
        display: "flex", justifyContent: "center", gap: 120,
        perspective: 1600,
      }}>
        {STAKES.map((s, i) => {
          const sp = spring({ frame: frame - 30 - i * 22, fps, config: SPRING.bouncy });
          const op = interpolate(sp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
          const scale = interpolate(sp, [0, 1], [0.3, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
          const rotY = Math.sin(frame * 0.018 + i * 2) * 10;
          const floatY = Math.sin(frame * 0.03 + i) * 10;
          return (
            <div key={s.label} style={{
              opacity: op,
              transform: `scale(${scale}) translateY(${floatY}px) perspective(1200px) rotateY(${rotY}deg)`,
              transformStyle: "preserve-3d",
              width: 380,
              textAlign: "center",
            }}>
              {/* Avatar orb */}
              <div style={{
                width: 220, height: 220,
                borderRadius: "50%",
                margin: "0 auto 28px",
                background: `radial-gradient(circle at 35% 30%, ${s.c}55, ${s.c}15 60%, transparent)`,
                border: `3px solid ${s.c}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 120,
                boxShadow: `0 0 50px ${s.c}77, 0 0 100px ${s.c}33, inset 0 0 40px ${s.c}22`,
              }}>
                {s.icon}
              </div>
              {/* Pedestal */}
              <div style={{
                height: 14,
                width: 260,
                margin: "0 auto",
                borderRadius: "50%",
                background: `radial-gradient(ellipse, ${s.c}88, transparent 70%)`,
                filter: "blur(2px)",
                marginTop: -10,
              }} />
              {/* Label */}
              <div style={{
                fontSize: 32,
                fontFamily: FONTS.heading,
                fontWeight: 800,
                color: s.c,
                marginTop: 20,
                textShadow: glow(s.c, true),
                letterSpacing: -0.5,
              }}>
                {s.label}
              </div>
              <div style={{
                fontSize: 20,
                fontFamily: FONTS.body,
                color: COLORS.textSecondary,
                marginTop: 8,
                fontWeight: 500,
              }}>
                {s.role}
              </div>
            </div>
          );
        })}
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
